import { events } from './adviserProfilePicturesEditorActions'

const initialState = {
  editingPictures: false,
  editingProfilePicture: false,
  editingCompanyLogo: false,
  submittingCompanyLogo: false,
  submittingProfilePicture: false,
  uploadingProfilePicture: false,
  profilePictureIsValid: true,
  oldProfilePicture: null
}

export default function (state = initialState, action) {
  const { edit, set, upload } = events
  switch (action.type) {
    case edit.start:
      state.profilePictures.editingPictures = true
      return state
    case edit.stop:
      state.profilePictures.editingPictures = false
      return state
    case edit.profilePic.start:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingProfilePicture = true
      state.profilePictures.oldProfilePicture = state.profile.profilePic
      return state
    case edit.profilePic.stop:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingProfilePicture = false
      state.profilePictures.oldProfilePicture = null
      return state
    case edit.profilePic.cancel:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingProfilePicture = false
      state.profile.profilePic = state.profilePictures.oldProfilePicture
      return state
    case set.profilePic:
      state.profile.profilePic = action.image
      state.profilePictures.profilePictureIsValid = action.image.length > ('data:image/jpeg;base64,data').length
      state.edited = true
      return state
    case upload.profilePic.uploading:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.uploadingProfilePicture = true
      return state
    case upload.profilePic.uploaded:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.uploadingProfilePicture = false
      return state
    /* Company Logo Stuff */
    case edit.companyPic.start:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingCompanyLogo = true
      state.profilePictures.oldCompanyPicture = state.profile.companyLogo
      return state
    case edit.companyPic.stop:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingCompanyLogo = false
      state.profilePictures.oldCompanyPicture = null
      return state
    case edit.companyPic.cancel:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.editingCompanyLogo = false
      state.profile.companyLogo = state.profilePictures.oldCompanyPicture
      return state
    case set.companyPic:
      state.profile.companyLogo = action.image
      state.profilePictures.companyPictureIsValid = action.image.length > ('data:image/jpeg;base64,data').length
      state.edited = true
      return state
    case upload.companyPic.uploading:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.uploadingCompanyPicture = true
      return state
    case upload.companyPic.uploaded:
      state.profilePictures = Object.assign({}, state.profilePictures)
      state.profilePictures.uploadingCompanyPicture = false
      return state
  }
  return state
}
